var _style, _path, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgManagerent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2000 2000",
    style: {
      enableBackground: "new 0 0 2000 2000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#F1F1F1;stroke:#060809;stroke-width:14;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st1{fill:#69C1C7;stroke:#060809;stroke-width:14;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st2{fill:#E85350;stroke:#060809;stroke-width:14;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st3{fill:#FCD479;stroke:#060809;stroke-width:14;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st4{fill:none;stroke:#060809;stroke-width:14;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st5{fill:none;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1370.1,908.3c5.7-0.5,11.6-0.9,17.4-0.9c105.8,0,191.5,85.8,191.5,191.5c0,105.8-85.8,191.5-191.5,191.5H699.9 c-129.8,0-235-105.2-235-234.9c0-129.8,105.2-235,235-235c18.6,0,36.8,2.5,54.3,6.6c35.6-133.9,157.3-232.8,302.5-232.8 c173.1,0,313.4,140.3,313.4,313.4C1370.1,907.7,1370.1,908,1370.1,908.3z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "1556.2,1577.9 882.1,1577.9 814.7,1544.2 814.7,1510.5 1623.6,1510.5 1623.6,1544.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1578.7,1510.5v-431.9v0c0-22.1-17.9-39.9-39.9-39.9h0h-639c-22.1,0-39.9,17.9-39.9,40v431.9H1578.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 907.4,
    y: 1099.3,
    className: "st0",
    width: 623.5,
    height: 370.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1295,
    y: 1402.6,
    className: "st2",
    width: 202.2,
    height: 33.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1295,
    y: 1133,
    className: "st3",
    width: 202.2,
    height: 67.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 941.1,
    y: 1368.9,
    className: "st3",
    width: 134.8,
    height: 67.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 941.1,
    y: 1133,
    className: "st2",
    width: 134.8,
    height: 202.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1202.3,1072.3h33.7H1202.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1331.5,1510.5c0,18.6-15.1,33.7-33.7,33.7h-157.3c-18.6,0-33.7-15.1-33.7-33.7c0,18.6,15.1,33.7,33.7,33.7 h157.3C1316.4,1544.2,1331.5,1529.1,1331.5,1510.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1109.6,1133h134.8H1109.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1109.6,1166.7h67.4H1109.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1295,1234.1h101.1H1295z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1295,1267.8h67.4H1295z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1295,1301.5h84.3H1295z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1295,1335.2h50.5H1295z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1295,1368.9h84.3H1295z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1429.8,1234.1h67.4H1429.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1429.8,1267.8h67.4H1429.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1429.8,1301.5h33.7H1429.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1109.6,1200.4h101.1H1109.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1109.6,1234.1h50.6H1109.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1109.6,1267.8h134.8H1109.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1109.6,1301.5h50.6H1109.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1109.6,1335.2h101.1H1109.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1109.6,1368.9h101.1H1109.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1109.6,1402.6h67.4H1109.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1109.6,1436.3h134.8H1109.6z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 122.9,
    y: 79.9,
    className: "st5",
    width: 1218.1,
    height: 1218.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M625.4,725.4v-97.2c0,0,0-0.1,0-0.1c0-25.2,20.5-45.7,45.7-45.7s45.7,20.5,45.7,45.7h0v97.4 c16.2,4.2,31.5,10.5,45.7,18.7V628h0c0-50.5-40.9-91.4-91.3-91.4c-50.4,0-91.4,40.9-91.4,91.4v116 C593.8,735.9,609.1,729.6,625.4,725.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M823.3,947.8l-60.9-45.7l30.4-45.7h54.9c-20.3-78.8-91.6-137.1-176.7-137.1c-100.9,0-182.7,81.8-182.7,182.8 c0,100.9,81.8,182.7,182.7,182.7c95.5,0,173.7-73.3,181.9-166.7L823.3,947.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M762.4,902.2l30.4-45.7h7.3c-18.8-53.2-69.4-91.4-129-91.4c-75.7,0-137,61.4-137,137.1 c0,75.7,61.4,137.1,137,137.1c64.8,0,119-45.1,133.2-105.6L762.4,902.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1066.9,810.8c-33.7,0-62.8,18.5-78.6,45.7H792.8l-30.4,45.7l60.9,45.7l30.4-30.5l30.5,30.5l30.5-30.5 l30.4,30.5h43.1c15.9,27.2,45,45.7,78.7,45.7c50.4,0,91.4-40.9,91.4-91.4C1158.3,851.7,1117.4,810.8,1066.9,810.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1112.6,902.2c0,12.6-10.2,22.8-22.8,22.8c-12.6,0-22.9-10.2-22.9-22.8c0-12.6,10.2-22.8,22.9-22.8 C1102.4,879.3,1112.6,889.5,1112.6,902.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 648.2,
    y: 848.8,
    className: "st4",
    width: 45.7,
    height: 106.6
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManagerent);
export default __webpack_public_path__ + "static/media/managerent.73c31d529f8772402f8e6d1f6182292b.svg";
export { ForwardRef as ReactComponent };